import { StatusSelect } from "./StatusSelect";

const fmt = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
};

export const RecordList = ({ items, kind, onOpen, onStatus }) => {
  if (!items.length) {
    return <p className="border border-dashed border-white/15 p-10 text-center text-[var(--bone-2)]" data-testid={`${kind}-empty`}>Nothing here yet.</p>;
  }
  return (
    <ul className="divide-y divide-white/10 border-y border-white/10" data-testid={`${kind}-list`}>
      {items.map((it) => (
        <li key={it.id} onClick={() => onOpen(it)} data-testid={`${kind}-row-${it.id}`}
          className="grid cursor-pointer gap-3 px-2 py-5 transition-colors hover:bg-white/[0.03] md:grid-cols-[1.4fr_1.2fr_1fr_auto] md:items-center md:gap-6">
          <div>
            <p className="font-semibold text-[var(--bone)]">{it.full_name}</p>
            <p className="text-sm text-[var(--bone-2)]">{kind === "enquiries" ? it.company_name || "—" : it.location || "—"}</p>
          </div>
          <div className="text-sm">
            <p className="text-[var(--bone)]">{kind === "enquiries" ? it.service : it.role}</p>
            <p className="text-[var(--bone-2)]">{it.phone} · {it.email}</p>
          </div>
          <p className="font-mono text-xs text-[var(--bone-2)]">{fmt(it.created_at)}</p>
          <StatusSelect value={it.status} onChange={(v) => onStatus(it, v)} testId={`${kind}-status-${it.id}`} />
        </li>
      ))}
    </ul>
  );
};
